// extracted by mini-css-extract-plugin
export default {"RegistryDiscountDisplay":"registry-discount-display__RegistryDiscountDisplay__Imi9J","RegistryDiscountDisplay__cta":"registry-discount-display__RegistryDiscountDisplay__cta__oG95U"};